var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","id":"app","fluid":""}},[_c('div',[_vm._v("404")]),_c('div',{staticClass:"txt"},[_vm._v(" NOT FOUND"),_c('span',{staticClass:"blink"},[_vm._v("_")])])])}
var staticRenderFns = []

export { render, staticRenderFns }